import { UserDropdown } from '@src/manageUsers/components/UserDropdown';
import type { User } from '@src/manageUsers/domain/User';
import type { SearchPermitBasicFilters } from '@src/permits/services/PermitApplicationClient';
import { useTranslation } from 'react-i18next';

interface Props {
  onFilterChange: (filters: SearchPermitBasicFilters) => void;
  value?: string;
}

export const ClaimedByFilter = ({ onFilterChange, value }: Props) => {
  const { t } = useTranslation();

  const handleUserChange = (user: User | null) => {
    onFilterChange({
      claimedBy: user?.id,
    });
  };

  return (
    <UserDropdown
      placeholder={t('permitSearch.agent')}
      selectedUser={value}
      onUserChange={handleUserChange}
    />
  );
};
